module.exports = __webpack_public_path__ + "media/images/sample/theme_2-a880cf55f646f63da3335a9e9e809da0.png";